import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Utils from '../../utils';
import store from '../../store';
import crossDocumentProtocol from './crossDocumentProtocol';
import promisePlugin from './promisePlugin';
import ReactIframeResizer from './IFrameResizer';

var getPreviewHost = function getPreviewHost(server, useEcrionServer, useMicroserviceBackend) {
  if (server) return server;
  if (useEcrionServer) return Utils.getHost();
  if (useMicroserviceBackend) return Utils.getHost({
    useMicroserviceBackend: useMicroserviceBackend
  });
  return '';
};

var getWithAccessToken = function getWithAccessToken(url) {
  if (!url) return url;
  if (url.indexOf('accessToken=') > -1) return url;

  var _store$getState = store.getState(),
      auth = _store$getState.auth;

  if (!auth || !auth.token) return url;
  var token = auth.token;
  var paramsSeparator = url.indexOf('?');

  if (paramsSeparator > -1) {
    return url.substring(0, paramsSeparator + 1) + "accessToken=".concat(token, "&") + url.substring(paramsSeparator + 1);
  }

  var hashSeparator = url.indexOf('#');

  if (hashSeparator > -1) {
    return url.substring(0, hashSeparator) + "?accessToken=".concat(token) + url.substring(hashSeparator);
  }

  return url + "?accessToken=".concat(token);
};
/**
 * @extends {React.Component<import('./types').FrameBaseProps>}
 */


var FrameBase =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FrameBase, _React$Component);

  function FrameBase() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FrameBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FrameBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.frame = React.createRef();

    _this.send = function (action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var iframe = _this.frame.current && _this.frame.current.refs.frame;
      if (!iframe) return;
      crossDocumentProtocol.send(iframe, _this.props.namespace + '.' + action, data);
    };

    _this.sendPromise = function (action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var iframe = _this.frame.current && _this.frame.current.refs.frame;
      if (!iframe) return Promise.reject(new Error('Frame is not yet initialized.'));
      var promise = promisePlugin.getPromise(action);
      if (promise) return promise.Promise;
      promise = promisePlugin.createPromise(action);
      crossDocumentProtocol.send(iframe, _this.props.namespace + '.' + action, data);
      return promise.Promise;
    };

    _this.onMessageReceived = function (eventName, eventData) {
      if (!eventName.startsWith(_this.props.namespace)) return;
      var action = eventName.substring(_this.props.namespace.length + 1);

      switch (action) {
        case 'Loaded':
          return _this.props.onLoaded && _this.props.onLoaded(eventData);

        default:
          _this.props.on && _this.props.on({
            action: action,
            data: eventData
          });
      }

      var actionParts = action.split('.');
      if (actionParts.length != 2) return;
      var actionName = actionParts[0];
      var actionResult = actionParts[1];
      if (!promisePlugin.getPromise(actionName)) return;
      actionResult === 'Resolved' ? promisePlugin.resolvePromise(actionName, {
        data: eventData
      }) : promisePlugin.rejectPromise(actionName, eventData);
      promisePlugin.removePromise(actionName);
    };

    return _this;
  }

  _createClass(FrameBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      crossDocumentProtocol.on(this.props.namespace, this.onMessageReceived);
      var iframe = this.frame.current && this.frame.current.refs.frame;
      if (iframe) iframe.allow = 'geolocation'; // allow geolocation in our iframe
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      crossDocumentProtocol.off(this.props.namespace, this.onMessageReceived);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          server = _this$props.server,
          useEcrionServer = _this$props.useEcrionServer,
          useMicroserviceBackend = _this$props.useMicroserviceBackend,
          url = _this$props.url,
          width = _this$props.width,
          height = _this$props.height,
          rest = _objectWithoutProperties(_this$props, ["server", "useEcrionServer", "useMicroserviceBackend", "url", "width", "height"]);

      var sv = getPreviewHost(server, useEcrionServer, useMicroserviceBackend);
      var urlWithAuth = getWithAccessToken(url);
      return React.createElement(ReactIframeResizer, Object.assign({
        ref: this.frame,
        key: url,
        iframeResizerEnable: height === 'auto',
        iframeResizerOptions: {
          checkOrigin: false
        },
        src: removeUnnecessarySlash(sv, urlWithAuth)
      }, rest, {
        style: _objectSpread({
          border: 'none',
          width: width,
          minHeight: 400,
          height: height
        }, rest.style)
      }));
    }
  }]);

  return FrameBase;
}(React.Component);

FrameBase.defaultProps = {
  useEcrionServer: false,
  useMicroserviceBackend: false,
  url: '',
  server: false,
  width: '100%',
  height: 'auto',
  style: {}
};

var removeUnnecessarySlash = function removeUnnecessarySlash(host, path) {
  if (!host) return path;
  if (host.endsWith('/')) host = host.substring(0, host.length - 1);
  if (path.startsWith('/')) path = path.substring(1, path.length);
  return "".concat(host, "/").concat(path);
};

export default FrameBase;